import React, { useCallback, useEffect } from 'react';
import { Container } from 'reactstrap';
// import BreadCrumb from 'Components/Common/BreadCrumb';
import { useLocation } from 'react-router-dom';

const NoAccess = () => {
  useEffect(() => {
    document.title = 'No Access | POS2U';
  }, []);
  const location = useLocation();
  const uri = location.pathname;

  const polishUri = useCallback((rawPath: string): string => {
    return rawPath
      .replace(/\/no-access/g, '')
      .replace(/\//g, '')
      .trim();
  }, []);

  // console.log(polishUri(uri));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* <BreadCrumb title="No Access" pageTitle="Access Denied" /> */}
          <div className="text-center mt-5">
            <h1 className="display-4 text-danger">403</h1>
            <p className="lead">
              You do not have permission to view{' '}
              <span className="fw-bolder text-danger">{polishUri(uri)}</span>{' '}
              page.
            </p>
            {/* <p className="text-muted">
              Please contact your administrator for more information.
            </p> */}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NoAccess;
